import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { widgetSelector } from "store/cross-slice/widgetSelector";
export const useSearchParam = () => useSelector((state) => state.addWidget.searchParam, isEqual);
export const useSearchName = () => useSelector((state) => state.addWidget.name);
export const useDisabledFilters = () => useSelector((state) => state.addWidget.disabledFilters);
export const useSelectedWidget = () => useSelector((state) => widgetSelector(state, state.addWidget.selectedWidgetId || ""), isEqual);
export const useIsSelectedWidget = (widgetId) => useSelector((state) => Boolean(widgetId && state.addWidget.selectedWidgetId === widgetId));
